// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ARDg8"};